/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const createStatisticsMapStyles = makeStyles((theme: Theme) =>
  createStyles({
    '@keyframes pulse': {
      '0%': {
        transform: 'scale(1);',
      },
      '60%': {
        transform: 'scale(.85);',
      },
      '100%': {
        transform: 'scale(1);',
      },
    },
    map: {
      position: 'absolute',
      width: 'calc(100% + 299px)',
      height: '100%',
      left: '-151px',
      right: '-148px',
    },
    mapCountry: {
      fill: theme.palette.primary.main,
    },
    mapCountrySelected: {
      fill: theme.palette.secondary.main,
    },
    mapCircle: {
      fill: 'transparent',
      transition: 'fill 0.2s linear',
    },
    mapCircleActive: {
      fill: theme.palette.secondary.main,
    },
    mapCircleInner: {
      animation: `$pulse 2s infinite`,
      opacity: '0.1',
    },
    mapCircleOuter: {
      animation: `$pulse 2s infinite`,
      opacity: '0.2',
    },
  }),
);

export { createStatisticsMapStyles };
